export default __webpack_public_path__ + "static/media/size_chart.271f8587.pdf";